import React, { useEffect, useState, useContext, createContext } from "react";
import {
  Button,
  PageHeader,
  Input,
  Row,
  Col,
  Select,
  Form,
  Card,
  Modal,
  Radio,
  InputNumber,
  message,
  Collapse,
  Divider,
  Progress,
  Spin,
} from "antd";
import {
  UploadOutlined,
  RedoOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import MobileDrawer from "./mobileDrawer";
import { configVariables } from "../../../../../../configs/configs";
import { getSummaryFromData, getItemValidation } from "../functions";
import { questionsVariations } from "../../../../../commonImports/data";
import RenderResponseWithAns from "../../../../../common/renderResponseWithAnsChat";
import VoiceCaptureComp from "../../../../../common/voiceCaptureComp";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { NavBar, Icon } from "antd-mobile";
import GoogleTranslator from "../../../../../common/googleTranslator";
import { getDataFromDbForm, checkConditions } from "../functions";
import templateFormBgSvg from "../../../../../../assets/templateFormBgSvg.svg";

const QuestionaireContext = createContext(null);

const responsiveStyles = {
  container: {
    backgroundColor: "transparent",
    padding: "0 20px",
  },
  buttonContainer: {
    width: "100%",
    maxWidth: "600px",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "20px",
    marginBottom: "80px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  actionButton: {
    flex: 1,
    minWidth: "160px",
    height: "48px",
    borderRadius: "25px",
    fontSize: "14px",
    fontFamily: "Montserrat",
    lineHeight: "17px",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
};

const helpTextStyles = `
.help-text-container img {
  max-width: 100% !important; /* Make sure images don't overflow their container */
  height: auto !important; /* Allow height to scale proportionally */
  max-height: 300px !important; /* Limit maximum height */
  object-fit: contain; /* Maintains aspect ratio */
}

@media (max-width: 768px) {
  .help-text-container img {
    max-height: 150px !important; /* Smaller height on tablets */
  }
}

@media (max-width: 480px) {
  .help-text-container img {
    max-height: 100px !important; /* Even smaller height on mobile phones */
  }
}
`;

const RedoRenderResponse = (props) => {
  const {
    list,
    form,
    rerenderCustom,
    validation,
    demoData,
    fullHeight = false,
  } = props;
  console.log(demoData, "dddddddddddddd");

  const [drawerOpen, setdrawerOpen] = useState(false);
  const [mainArr, setmainArr] = useState([]);
  const [activeArr, setactiveArr] = useState([]);
  const [conditionsArr, setconditionsArr] = useState([]);
  const [activeIndex, setactiveIndex] = useState(0);
  const [loading, setloading] = useState(false);
  const [activeSummary, setactiveSummary] = useState("");
  const [totalLength, settotalLength] = useState(0);
  const [mainArrActiveIndex, setmainArrActiveIndex] = useState(0);
  const [flag, setflag] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);

  // const [resetFlag, setresetFlag] = userState(false)

  let values = form.getFieldsValue();

  let name = activeArr[activeIndex] ? activeArr[activeIndex].slugValueNew : "";

  const onOpenChange = (res) => {
    setdrawerOpen(!drawerOpen);
  };

  useEffect(() => {
    if (form.getFieldsValue()[name]) {
      setactiveSummary(form.getFieldsValue()[name].summary);
    }
  }, [values]);

  useEffect(() => {
    if (form.getFieldsValue()[name]) {
      setactiveSummary(form.getFieldsValue()[name].summary);
    }
  }, [activeIndex]);

  useEffect(() => {
    setloading(true);
    let mainArrCopy = [];
    let conditionsArrCopy = [];

    props.list.forEach((item, m) => {
      if (
        (item &&
          item != null &&
          item.typeValue &&
          item.typeValue.includes("subtemplate")) ||
        (item && item != null && item.type && item.type.includes("subtemplate"))
      ) {
        let obj = getDataFromDbForm(item);

        obj.rows.map((a, i) => {
          a.columns.map((b, j) => {
            b.sections.map((c, k) => {
              c.questions.map((d, l) => {
                d.conditions = item.conditions;
                d.slugValueNew = `${d.slugValue}-${i}-${j}-${k}-${l}-${m}`;
                conditionsArrCopy.push(d);
              });
            });
          });
        });
      } else {
        if (item && item != null && item.typeValue != "LONG_TEXT") {
          let itemValidation = getItemValidation(item);
          let flag = checkValidation(itemValidation);

          if (flag == true && item.conditions == undefined) {
            mainArrCopy.push(item);
          }
          if (flag == true && item.conditions != undefined) {
            conditionsArrCopy.push(item);
          }
        } else {
          mainArrCopy.push(item);
        }
      }
    });

    setmainArr(mainArrCopy);
    setconditionsArr(conditionsArrCopy);
    settotalLength(mainArrCopy.length);

    if (mainArrCopy.length > 0) {
      setactiveArr([mainArrCopy[0]]);
      setactiveIndex(0);
      setmainArrActiveIndex(0);
    }

    setloading(false);
  }, [props.list]);

  useEffect(() => {
    if (props.changedValue) {
      onChangePopQuestionsout(props.changedValue);
    }
  }, [props.changedValue]);

  const onChangePopQuestionsout = (changed) => {
    let arr = [...activeArr];
    let index = arr.findIndex((a) => a.slugValueNew == changed);
    if (index != -1 && index != activeArr.length - 1) {
      let poppedArr = arr.splice(index + 1, arr.length - 1);

      let filteredArr = poppedArr.filter((a) => {
        if (!a.conditions) {
          return a;
        }
      });

      setactiveArr(arr);
      setactiveIndex(index);
      setmainArrActiveIndex((i) => i - filteredArr.length);
    }
  };

  const getSummaryFromAnswers = () => {
    let values = form.getFieldsValue();
    let htmlStr = "";
    let obj = getSummaryFromData(props.list, values);
    htmlStr = obj.htmlStr;
    return htmlStr;
  };

  const checkValidation = (itemValidation) => {
    // return validation flag
    let flag = true;

    if (validation && itemValidation) {
      if (
        validation.age != null &&
        itemValidation.ageFrom != null &&
        validation.age < itemValidation.ageFrom
      ) {
        flag = false;
      }
      if (
        validation.age != null &&
        itemValidation.ageTo != null &&
        validation.age > itemValidation.ageTo
      ) {
        flag = false;
      }
      if (
        validation.gender != null &&
        itemValidation.gender != null &&
        validation.gender.trim().toLowerCase() !=
          itemValidation.gender.trim().toLowerCase()
      ) {
        flag = false;
      }
    }
    return flag;
  };

  // const checkConditions = (ques) => {
  //   // return conditions flag
  //   if (ques != null) {
  //     let conditions = ques.conditions;
  //     let values = form.getFieldsValue()
  //     // console.log(values)
  //     let flag = false;

  //     conditions && conditions.map((item) => {
  //       let val = item.value ? item.value : item.val;
  //       if (Object.keys(values).length > 0) {
  //         if (values[val.quesSlug]) {

  //           let demo = questionsVariations.find((x) => {
  //             if (x.value == val.summary) {
  //               return x
  //             }
  //           })

  //           if (demo && demo.value == '<' && values[val.quesSlug].answer <= val.response) {
  //             flag = true
  //           }
  //           if (demo && demo.value == '>' && values[val.quesSlug].answer >= val.response) {
  //             flag = true
  //           }
  //           if (demo == undefined && Array.isArray(values[val.quesSlug].answer) && values[val.quesSlug].answer.includes(val.response)) {
  //             flag = true
  //           }
  //           if (demo == undefined && !Array.isArray(values[val.quesSlug].answer) && values[val.quesSlug].answer == val.response) {
  //             flag = true
  //           }
  //         }
  //       }
  //     })
  //     return flag;
  //   }
  // }

  const findNextQuestion = () => {
    if (activeIndex < activeArr.length - 1) {
      setactiveIndex((i) => i + 1);
    } else {
      let arr = [...activeArr];
      let condArr = conditionsArr.filter((a) => {
        let flag = checkConditions(a, form.getFieldsValue());
        let obj = arr.find((x) => x.slugValueNew == a.slugValueNew);
        if (flag == true && !obj) {
          return a;
        }
      });

      if (condArr.length > 0) {
        arr.push(condArr[0]);
        setactiveSummary(undefined);
        setactiveArr(arr);
        setactiveIndex((i) => i + 1);
        settotalLength((i) => i + 1);
      } else {
        if (mainArr[mainArrActiveIndex + 1]) {
          arr.push(mainArr[mainArrActiveIndex + 1]);
          setactiveSummary(undefined);
          setmainArrActiveIndex((i) => i + 1);
          // settotalLength(i => i+1)
        }
        setactiveIndex((i) => i + 1);
        setactiveArr(arr);
      }
    }
  };

  const next = () => {
    if (props.setchangedValue) {
      props.setchangedValue(undefined);
    }
    setflag(!flag);

    let isRequired = activeArr[activeIndex]
      ? activeArr[activeIndex].isRequired
      : false;

    if (isRequired == true) {
      let formValues = form.getFieldsValue();
      if (formValues[name]) {
        if (
          formValues[name].answer == undefined ||
          formValues[name].answer == null
        ) {
          message.warning("Please answer question");
          return;
        } else {
          findNextQuestion();
          SpeechRecognition.stopListening();
        }
      } else {
        message.warning("Please answer question");
        return;
      }
    } else {
      findNextQuestion();
      SpeechRecognition.stopListening();
    }
    var str = document.getElementById("custom-shadowA3").innerHTML;
    var str2 = `<link href="${
      configVariables.amplifyUrl
    }/static/css/13.80e6c6f2.chunk.css" rel="stylesheet">
    <link href="${
      configVariables.amplifyUrl
    }/static/css/main.0cafd1e4.chunk.css" rel="stylesheet">
    <div style="margin:0 12.5%;">
    ${str.replaceAll("display: none;", "")}</div>`;
    // console.log(str2, "hhhhhtm111lllll");
    form.setFieldsValue({
      htmlConsent: str2,
    });
  };

  const prev = () => {
    if (props.setchangedValue) {
      props.setchangedValue(undefined);
    }
    setflag(!flag);
    if (activeIndex != 0) {
      SpeechRecognition.stopListening();
      setactiveIndex(activeIndex - 1);
    }
  };

  const reset = () => {
    form.resetFields();
    setactiveArr([mainArr[0]]);
    setactiveIndex(0);
    setmainArrActiveIndex(0);
    setactiveSummary(undefined);
    setdrawerOpen(false);
    settotalLength(mainArr.length);
    SpeechRecognition.stopListening();
  };

  const renderQuestion = (a, index) => {
    let showLabel =
      a.questionType == "FILL_IN_BLANKS" || a.questionType == "TABLE"
        ? false
        : true;

    if (a.typeValue == "LONG_TEXT") {
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "10px",
            marginBottom: "10px",
            display: index == activeIndex ? "block" : "none",
          }}
          dangerouslySetInnerHTML={{ __html: a.htmlContent }}
        ></div>
      );
    } else {
      return (
        <div
          style={
            index == activeIndex
              ? { textAlign: "left", padding: "10px" }
              : { display: "none" }
          }
        >
          {showLabel == true && (
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "bolder",
                color: "#00003B",
              }}
            >
              {/* add a black square before the question title */}
              <span
                style={{
                  marginRight: "5px",
                  fontSize: "10px",
                  color: "#00003B  ",
                }}
              >
                ■
              </span>
              {a.questionTitle}
            </h2>
          )}
          {/* <p style={{ color: 'grey', fontSize: 13 }}>{a.helpText}</p> */}
          {a.helpText && (
            <div
              className="help-text-container"
              style={{
                backgroundColor: "white",
                padding: "10px",
                marginBottom: "10px",
              }}
              dangerouslySetInnerHTML={{ __html: a.helpText }}
            ></div>
          )}
          <RenderResponseWithAns
            chat={true}
            record={a}
            form={form}
            rerenderCustom={rerenderCustom}
          />
          {
            //   ((a.addNote == true || activeSummary !== undefined)) &&
            <div style={{ display: "flex" }}>
              {/*  by Amruta PAwar */}
              {a.addNote == true && (
                <Input.TextArea
                  autoSize={true}
                  value={activeSummary}
                  placeholder="Note"
                  style={{
                    flex: 1,
                    fontSize: "15px",
                    minHeight: "50px",
                    marginBottom: "10px",
                    color: "#00003B",
                  }}
                  onChange={(e) => {
                    setactiveSummary(e.target.value);
                    form.setFieldsValue({
                      [name]: {
                        summary: e.target.value,
                      },
                    });
                  }}
                  onBlur={(e) => {
                    setactiveSummary(e.target.value);
                    form.setFieldsValue({
                      [name]: {
                        summary: e.target.value,
                      },
                    });
                  }}
                />
              )}
            </div>
          }
          {/* amruta tempo */}
          <Form.Item name={[a.slugValueNew, "summary"]}></Form.Item>
          <Form.Item name={[a.slugValueNew, "voiceNote"]}></Form.Item>
          {/* amruta tempo */}
        </div>
      );
    }
  };

  // let percentageCalc = activeArr.length <= (mainArr.length) ? (activeArr.length / (mainArr.length)) * 100
  //   : ((activeArr.length - mainArr.length) / activeArr.length) * 100;

  let percentageCalc = ((activeIndex + 1) * 100) / totalLength;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <QuestionaireContext.Provider values={{ mainArr: mainArr }}>
      <style>{helpTextStyles}</style>
      <div style={responsiveStyles.container}>
        <MobileDrawer
          setactiveIndex={setactiveIndex}
          form={form}
          drawerOpen={drawerOpen}
          onOpenChange={onOpenChange}
          list={activeArr}
          fullHeight={fullHeight}
        >
          <NavBar
            style={{ backgroundColor: "transparent", height: "20px"}}
            mode="light"
            leftContent={[
              <RedoOutlined
                style={{ color: "#00003B" }}
                onClick={() => {
                  reset();
                }}
              />,
            ]}
            rightContent={[
              <Button
                htmlType="submit"
                type="link"
                loading={props.loading}
                onClick={() => {
                  form.setFieldsValue({
                    status: "EDIT",
                  });
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bolder",
                    color: "#00003B",
                  }}
                >
                  Save For Later
                </span>
              </Button>,
              <Icon
                key="1"
                type="ellipsis"
                color="#00003B"
                onClick={() => onOpenChange()}
              />,
            ]}
          ></NavBar>
          <div>
            <Progress
              showInfo={false}
              percent={percentageCalc}
              strokeColor={{
                from: "#108ee9",
                to: "#87d068",
              }}
            />
          </div>
          <h2
            style={{ textAlign: "center", marginBottom: 0, color: "#00003B" }}
          >
            {demoData?.displayName ? demoData?.displayName : demoData?.title}
          </h2>

          {loading == true && (
            <div style={{ textAlign: "center" }}>
              <Spin />
            </div>
          )}
          {activeIndex !== activeArr.length && (
            <div
              id={"custom-shadowA3"}
              style={{
                backgroundImage: `url(${templateFormBgSvg})`,
                backgroundColor: "#fff",
                backgroundRepeat: "repeat-y",
                backgroundSize: "cover",
                height: "calc(100vh - 450px)",                
                overflowX: "hidden",
              }}
            >
              {activeArr.map((a, i) => {
                return <div>{renderQuestion(a, i)}</div>;
              })}
            </div>
          )}

          <Form.Item name="status" style={{ display: "none" }}></Form.Item>
          <Form.Item name="htmlConsent" style={{ display: "none" }}></Form.Item>

          {activeIndex == activeArr.length ? (
            <>
              <div style={{
                backgroundImage: `url(${templateFormBgSvg})`,
                backgroundColor: "#fff",
                backgroundRepeat: "repeat-y",
                backgroundSize: "cover",
                height: "100%",
                overflowY: "auto",
                height: "calc(100vh - 450px)",                
                padding: "16px",
              }}>
                  <div
                    style={{ marginBottom: "20px", color: "black" }}
                    dangerouslySetInnerHTML={{
                      __html: getSummaryFromAnswers(),
                    }}
                  ></div>
                    {/* <Button htmlType="submit" type="link" style={{ marginBottom: '10px' }} onClick={() => {
                    form.setFieldsValue({
                      status: 'EDIT'
                      })
                      }}>Save For Later</Button> */}
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "center", 
                      marginBottom: "20px" 
                    }}>
                      <Button
                        size="large"
                        type="primary"
                        style={{
                          margin: isSmallMobile ? "5px 0" : "0px 1px",
                          height: isSmallMobile ? "40px" : "48px",
                          width: "50%",
                          border: "1px solid #254edb",
                          borderRadius: "25px",
                          backgroundColor: "#ebf4ff",
                          fontSize: isSmallMobile ? "12px" : "14px",
                          color: "#254edb",
                          fontFamily: "Montserrat-Medium",
                          lineHeight: "17px",
                        }}
                        htmlType="submit"
                        loading={props.loading}
                        onClick={() => {
                          form.setFieldsValue({
                            status: "EDIT",
                          });
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    {/* <Button type="primary" inline size="large"                            
                    onClick={() => {
                      reset()
                      
                      }}>Reset <RedoOutlined />
                      </Button> */}
              </div>
            </>
          ) : (
            <>
              {/* <Button htmlType="submit" type="link" onClick={() => {
                  form.setFieldsValue({
                    status: 'EDIT'
                    })
                    }}>Save For Later</Button> */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  backgroundColor: "#fff",
                  maxWidth: "100%",
                  width: "100%",
                }}
              >
                <div style={{ 
                  display: "flex", 
                  flexDirection: isMobile ? "column" : "row",
                }}>
                  {/* commented by Amruta PAwar voice note capture duplicate, uncommented by pravin dt 10102024 */}
                  <Input.TextArea
                    value={activeSummary}
                    placeholder="Note"
                    style={{
                      flex: 1,
                      fontSize: "15px",
                      borderRadius: "8px",
                      marginBottom: "10px",
                      marginLeft: "5px",
                      height: "120px",
                      color: "#00003B",
                      marginRight: "5px",
                      width: "calc(100% - 10px)",
                    }}
                    onChange={(e) => {
                      console.log(e, "noeeeeeeeeeeee");
                      setactiveSummary(e.target.value);
                      form.setFieldsValue({
                        [name]: {
                          summary: e.target.value,
                        },
                      });
                    }}
                  />
                  {/* commented by Amruta PAwar voice note capture duplicate end */}

                  {/* <VoiceCaptureComp
                    setvoiceInputText={(valText) => {
                      setactiveSummary(valText)
                      form.setFieldsValue({
                        [name]: {
                          summary: valText
                        }
                      })
                    }} /> */}
                </div>
                <div style={{ 
                  display: "flex",
                  flexDirection: "row"
                }}>
                  {/* <Button type="primary" inline size="large"
                    style={{ flex: 1 }}
                    onClick={() => {
                      reset()

                    }}>Reset <RedoOutlined />
                  </Button> */}

                  <Button
                    type="primary"
                    style={{
                      margin: isSmallMobile ? "5px 0" : "0px 1px",
                      flex: 1,
                      height: isSmallMobile ? "40px" : "48px",
                      width: "100%",
                      border: "1px solid #254edb",
                      borderRadius: "25px",
                      backgroundColor: "#ebf4ff",
                      fontSize: isSmallMobile ? "12px" : "14px",
                      color: "#254edb",
                      fontFamily: "Montserrat-Medium",
                      lineHeight: "17px",
                    }}
                    inline
                    size={isSmallMobile ? "middle" : "large"}
                    onClick={() => {
                      prev();
                    }}
                  >
                    Prev <DoubleLeftOutlined />
                  </Button>

                  <Button
                    size={isSmallMobile ? "middle" : "large"}
                    style={{
                      margin: isSmallMobile ? "5px 0" : "0px 1px",
                      flex: 1,
                      height: isSmallMobile ? "40px" : "48px",
                      width: "100%",
                      border: "1px solid #254edb",
                      borderRadius: "25px",
                      backgroundColor: "#ebf4ff",
                      fontSize: isSmallMobile ? "12px" : "14px",
                      color: "#254edb",
                      fontFamily: "Montserrat-Medium",
                      lineHeight: "17px",
                    }}
                    inline
                    type="primary"
                    onClick={() => {
                      next();
                    }}
                  >
                    Next <DoubleRightOutlined />
                  </Button>
                </div>
                <Form.Item
                  name={[name, "voiceCapture"]}
                  style={{ 
                    flex: 1, 
                    marginBottom: "10px", 
                    marginRight: "5px",
                    width: "calc(100% - 10px)",
                    maxWidth: "100%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <VoiceCaptureComp
                      flag={flag}
                      data={values[name] ? values[name].voiceNote : undefined}
                      setvoiceInputText={(valText, voiceNote) => {
                        if (valText) {
                          setactiveSummary(valText);

                          form.setFieldsValue({
                            [name]: {
                              summary: valText,
                            },
                          });
                        }

                        form.setFieldsValue({
                          [name]: {
                            voiceNote: voiceNote,
                          },
                        });
                      }}
                    />
                  </div>
                </Form.Item>
              </div>
            </>
          )}
        </MobileDrawer>
      </div>
    </QuestionaireContext.Provider>
  );
};

export default RedoRenderResponse;
